import { createRouterSelector, useRouterStoreActions } from '@atlassian/react-resource-router';

const useQuery = createRouterSelector((o) => o.query);

/*
 * Why does this exist?
 * The hook that react resource router provides useQueryParam only allows getting/updating one param per hook
 * and does not work correctly when performing two updates within a single render cycle due to stale query state
 *
 * This hook allows updating multiple query params in one call and does not suffer from the same issue
 *
 * See slack thread https://atlassian.slack.com/archives/C07JUC8ALCT/p1729833618568029
 */
export const useQueryParams = () => {
	const routerStoreActions = useRouterStoreActions();
	const query = useQuery();

	return [query, routerStoreActions.updateQueryParam] as const;
};
